<template>
  <el-container style="height: 100vh;">
    <el-header class="header">
      <div class="header-bar">
        <div class="header-left">
          <div class="title">
            <span class="leaf">🌿</span>
            智慧后勤管理系统
          </div>
        </div>
        <div class="back">
          <img src="../../images/u2705.svg" />
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{ adminName }}
              <el-icon class="el-icon--right">
                <ArrowDown />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="goBack">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <el-dialog title="提示" v-model="dialogVisibleBack" width="380px">
        <span>
          <el-icon style="margin-right: 10px">
            <Warning />
          </el-icon>
          是否确认退出??
        </span>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisibleBack = false">取 消</el-button>
            <el-button type="success" @click="readGoBack">确 定</el-button>
          </span>
        </template>
      </el-dialog>
    </el-header>

    <el-container class="body-container">
      <el-aside :width="isCollapse ? '64px' : '200px'" class="aside">
        <div class="aside-inner">
          <el-menu
            :default-active="menu"
            :collapse="isCollapse"
            :unique-opened="true"
            :router="false"
            :collapse-transition="false"
            background-color="#43a047"
            text-color="#ffffff"
            active-text-color="#ffffff"
          >
            <el-menu-item index="/index" @click="saveMenu('/index')">
              <el-icon><House /></el-icon>
              <template #title>首页</template>
            </el-menu-item>

            <el-menu-item
              index="/Views/Order"
              @click="saveMenu('/Views/Order')"
              v-if="isAdmin || isMerchant"
            >
              <el-icon><Document /></el-icon>
              <template #title>订单管理</template>
            </el-menu-item>


            <el-menu-item
              index="/Views/CouponManage"
              @click="saveMenu('/Views/CouponManage')"
              v-if="isAdmin"
            >
              <el-icon><Ticket /></el-icon>
              <template #title>优惠券管理</template>
            </el-menu-item>

            <el-menu-item
              index="/Views/ScoreManage"
              @click="saveMenu('/Views/ScoreManage')"
              v-if="isAdmin"
            >
              <el-icon><Coin /></el-icon>
              <template #title>积分管理</template>
            </el-menu-item>
            <el-menu-item
              index="/Views/CanteenMenu"
              @click="saveMenu('/Views/CanteenMenu')"
              v-if="isAdmin || isMerchant"
            >
              <el-icon><Dish /></el-icon>
              <template #title>菜单管理</template>
            </el-menu-item>
            <el-menu-item
              index="/Views/MerchantManage"
              @click="saveMenu('/Views/MerchantManage')"
              v-if="isAdmin"
            >
              <el-icon><Shop /></el-icon>
              <template #title>商户管理</template>
            </el-menu-item>
            <el-menu-item
              index="/Views/IotConfig"
              @click="saveMenu('/Views/IotConfig')"
              v-if="isAdmin"
            >
              <el-icon><Bell /></el-icon>
              <template #title>IoT管理</template>
            </el-menu-item>

            <el-menu-item
              index="/systemInfo/notice"
              @click="saveMenu('/systemInfo/notice')"
              v-if="isAdmin"
            >
              <el-icon><Bell /></el-icon>
              <template #title>公告管理</template>
            </el-menu-item>

            <el-menu-item
              index="/users/UserManage"
              @click="saveMenu('/users/UserManage')"
              v-if="isAdmin"
            >
              <el-icon><UserFilled /></el-icon>
              <template #title>用户管理</template>
            </el-menu-item>
          </el-menu>

          <!-- 底部折叠按钮 -->
          <div class="aside-footer" @click="toggleCollapse">
            <el-icon :size="20">
              <Fold v-if="!isCollapse" />
              <Expand v-else />
            </el-icon>
            <span v-if="!isCollapse" class="footer-text">收起菜单</span>
          </div>
        </div>
      </el-aside>

      <el-main class="main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import {
  ArrowDown, Warning, House, Document,
  Ticket, Coin, Dish, Bell, UserFilled,
  Fold, Expand
} from '@element-plus/icons-vue'

const router = useRouter()

const adminName = ref('')
const dialogVisibleBack = ref(false)
const menu = ref('')
const isCollapse = ref(true)

const savedCollapse = localStorage.getItem('menuCollapse')
if (savedCollapse !== null) {
  isCollapse.value = savedCollapse === 'true'
}

const toggleCollapse = () => {
  isCollapse.value = !isCollapse.value
  localStorage.setItem('menuCollapse', isCollapse.value ? 'true' : 'false')
}

const roles = ref(JSON.parse(localStorage.getItem('roles') || '["normal"]'))
const hasRole = (r) => roles.value.includes(r)

const isSuperuser = computed(() => hasRole('superuser'))
const isStaff = computed(() => hasRole('staff'))
const isMerchant = computed(() => hasRole('merchant_admin'))
const isAdmin = computed(() => isSuperuser.value || isStaff.value)

onMounted(() => {
  adminName.value = localStorage.getItem('adminName') || ''
  menu.value = localStorage.getItem('menu') || ''
  roles.value = JSON.parse(localStorage.getItem('roles') || '["normal"]')
})

const goBack = () => {
  dialogVisibleBack.value = true
}

const readGoBack = () => {
  dialogVisibleBack.value = false
  localStorage.setItem('adminName', '')
  localStorage.setItem('tokenStartTime', '')
  localStorage.setItem('menu', '')
  localStorage.setItem('roles', '')
  router.push('/login')
}

const saveMenu = (path) => {
  localStorage.setItem('menu', path)
  menu.value = path
  router.push(path)
}
</script>

<style lang="less" scoped>
/* ===== 顶部 ===== */
.header {
  padding: 0;
  height: 60px;
  background: #43a047;
  box-shadow: 0 2px 8px rgba(67, 160, 71, 0.3);
}

.header-bar {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #43a047;
}

.header-left {
  display: flex;
  align-items: center;
  height: 60px;
}

.title {
  font-size: 20px;
  color: #fff;
  height: 60px;
  line-height: 60px;
  padding: 0 24px;
  font-weight: 600;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.leaf {
  font-size: 24px;
  line-height: 1;
}

.back {
  display: flex;
  align-items: center;
  padding-right: 24px;
  height: 60px;
}

.back img {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: #2e7d32;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 4px;
  box-sizing: border-box;
  margin-right: 10px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 14px;
}

:deep(.el-icon-arrow-down) {
  color: #fff !important;
}

/* ===== 主体 ===== */
.body-container {
  height: calc(100vh - 60px);
}

.aside {
  background-color: #43a047;
  transition: width 0.3s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.aside-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.aside :deep(.el-menu) {
  flex: 1;
  background-color: #43a047 !important;
  border: none;
  margin-top: 0;
  overflow-y: auto;
}

.aside :deep(.el-menu .el-icon) {
  color: #ffffff !important;
  font-size: 18px;
}

.aside :deep(.el-menu-item) {
  height: 48px;
  line-height: 48px;
  padding: 0 16px !important;
  margin: 0 !important;
  background-color: #43a047 !important;
  color: #ffffff !important;
  transition: all 0.2s;
}

.aside :deep(.el-menu-item:hover) {
  background: #66bb6a !important;
  color: #fff !important;
}

.aside :deep(.el-menu-item.is-active) {
  background: #2e7d32 !important;
  color: #fff !important;
  border-left: 4px solid #c8e6c9;
}

.aside :deep(.el-menu-item.is-active .el-icon) {
  color: #c8e6c9 !important;
}

.aside :deep(.el-menu--collapse) {
  width: 64px;
}

.aside :deep(.el-menu--collapse .el-menu-item) {
  padding: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.aside-footer {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  color: #fff;
  background: #43a047;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  transition: background 0.3s;
  flex-shrink: 0;
}

.aside-footer:hover {
  background: #2e7d32;
}

.footer-text {
  font-size: 14px;
}

/* ===== 内容区 ===== */
.main {
  background-color: #f3f8ff;
  color: #333;
  margin: 5px 20px 0;
  height: calc(100vh - 60px);
  overflow-y: auto;
  padding: 16px;
  box-sizing: border-box;
}
</style>